// extracted by mini-css-extract-plugin
module.exports = {"Panel":"Panel_Panel__3MTlv","PanelHeader":"Panel_PanelHeader__13AVL","PanelBody":"Panel_PanelBody__guP-K"};